import { useState, createContext, useContext } from "react";
const useStatesCntx = createContext();
const setStatesCntx = createContext();
export function StatesCntx({ children }) {
    const [stStates, setStStates] = useState({});
    return (
        <useStatesCntx.Provider value={stStates}>
            <setStatesCntx.Provider value={setStStates}>
                {children}
            </setStatesCntx.Provider>
        </useStatesCntx.Provider>
    )
}
export function UseStates() {
    return useContext(useStatesCntx);
}
export function SetStates() {
    return useContext(setStatesCntx);
}